import { render } from "./Show.vue?vue&type=template&id=5dd2f139"
import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Graphs/Show.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dd2f139"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dd2f139', __exports__)) {
    api.reload('5dd2f139', __exports__)
  }
  
  module.hot.accept("./Show.vue?vue&type=template&id=5dd2f139", () => {
    api.rerender('5dd2f139', render)
  })

}


export default __exports__